import { Config } from 'convict';
import { ClientConfig } from '../types/ClientConfig';
import { clientConfigSchema } from '../types/clientConfigSchema';
import convict from './convict';

const defaultClientConfig: Config<ClientConfig> = convict<ClientConfig>(clientConfigSchema).load({
    app: {
        url: process.env.NEXT_PUBLIC_APP_URL,
        starUrl: process.env.NEXT_PUBLIC_STAR_APP_URL,
        env: process.env.NEXT_PUBLIC_ENV,
        growthBookKey: process.env.NEXT_PUBLIC_GROWTH_BOOK_KEY || '',
        quoteExpiryDays: Number(`${process.env.NEXT_PUBLIC_QUOTE_EXPIRY_DAYS || 5}`),
        versionInfo: {
            commit: process.env.NEXT_PUBLIC_COMMIT_HASH || '',
            build: Number(process.env.NEXT_PUBLIC_BUILD_NO || 0),
            user: process.env.NEXT_PUBLIC_BUILD_USER || '',
            host: process.env.NEXT_PUBLIC_BUILD_HOST || '',
            date: process.env.NEXT_PUBLIC_BUILD_DATE || '',
            timestamp: Number(process.env.NEXT_PUBLIC_BUILD_TIMESTAMP || 0),
        },
        blockEditHolidaySurchargeBooking: process.env.NEXT_PUBLIC_BLOCK_EDIT_HOLIDAY_SURCHARGE_BOOKING || false,
        vffEligibleHoursBeforeDropOff: process.env.NEXT_PUBLIC_VFF_ELIGIBLE_HOURS_BEFORE_DROP_OFF || 24,
    },
    website: {
        baseUrl: process.env.NEXT_PUBLIC_WEBSITE_BASE || 'https://www.jucy.com',
    },
    starWebsite: {
        baseUrl: process.env.NEXT_PUBLIC_WEBSITE_STAR_BASE || 'https://www.starrv.com',
    },
    au: {
        translatorUrl: process.env.NEXT_PUBLIC_AU_TRANSLATOR_URL,
    },
    nz: {
        translatorUrl: process.env.NEXT_PUBLIC_NZ_TRANSLATOR_URL,
    },
    firebase: {
        apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
        authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
        projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
        storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
        measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
    },
    rentalsApi: {
        baseUrl: process.env.NEXT_PUBLIC_RENTALS_API_BASE_URL,
    },
    maintenance: {
        showMessage: process.env.NEXT_PUBLIC_MAINTENANCE_SHOW_MESSAGE,
    },
    googleMaps: {
        apiKey: process.env.NEXT_PUBLIC_GMAPS_API_KEY,
    },
    hotjar: {
        id: process.env.NEXT_PUBLIC_HOTJAR_ID ? Number(process.env.NEXT_PUBLIC_HOTJAR_ID) : null,
        sv: process.env.NEXT_PUBLIC_HOTJAR_SV ? Number(process.env.NEXT_PUBLIC_HOTJAR_SV) : null,
    },
    terms26: {
        payLater: {
            minDaysBeforePickupFallback: Number(process.env.NEXT_PUBLIC_TERMS26_PAY_LATER_MIN_DAYS_BEFORE_PICKUP_FALLBACK || 7),
        },
    },
}) as unknown as Config<ClientConfig>;
export default defaultClientConfig;
